export default __webpack_public_path__ + "static/media/TrainingPortalIcon.a4b4f8f2.svg";